var en = {
	'菜单': 'MENU',
	'搜索': 'search',
	'关闭': 'close',
	'没有结果，请输入其他关键字': 'No results, please enter other keywords',
	'手表系列': 'BRAND',
	'新闻模块': 'News center',
	'防伪检测': 'Security testing',
	'关注': 'follow',
	'成为我们的一员': 'Become one of us',
	'打开微信扫一扫': 'Open WeChat and scan',
	'关于品牌': 'About the brand',
	'全部手表': 'All the watches',
	'探索': 'explore',
	'巴博斯腕表': 'The essence of the wrist',
	'品牌与帆船运动界的深厚渊源，最早可追溯至1950年代。启发自此悠久传统，游艇名仕型腕表集实用功能与非凡风格于一身，而游艇名仕型 II计时腕表则为劳力士超卓技术结晶，专为帆船赛计时而设计。': 'The brand has a deep relationship with the world of sailing dating back to the 1950s. Inspired from this long tradition, yacht famous TYPE WATCH set practical function and special style in a suit.',
	'防伪监测文案': 'Security monitoring',
	'游艇名仕型结合非凡风格与性能，从容应对海中或船上的各种场合。凭借其防水和坚固特质，成为水上运动以至扬帆出海的腕表之选。': 'Yachting FAMOUS MODEL COMBINES SPECIAL STYLE AND PERFORMANCE, COPE WITH THE SEA CALMLY OR ALL SORTS OF OCCASIONS ON .',
	'甄别自己': 'Identify the product',
	'联系我们': 'Contact us',
	'查看新闻': 'See the news',
	'探寻附近门店': 'Explore nearby stores',
	'品牌新闻': 'News center',
	'全部': 'ALL',
	'防伪检测查询': 'Anti-counterfeiting detection query',
	'输入防伪码': 'Enter the security code',
	'输入20位纯数字校验': 'Enter a 20-digit pure numeric check',
	'查询': 'QUERY',
	'商品不正确': 'The goods are not correct',
	'商品为正版': 'The goods are genuine',
	'重新检测': 'RETEST',
	'联系电话': 'phone number',
	'联系邮箱': 'email',
	'探索尊贵非凡且精准可靠的巴博斯腕表': 'Explore the noble and extraordinary and accurate and reliable refined wrist watch',
	'一系列图集': "A series of atlas",
	'技术规格': 'Technical specifications',
	'其他推荐': 'Other recommended',
	'巴博斯腕表精品店':'Jingli Watch Boutique',
	'凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。':'With rich experience and professional knowledge, we sincerely help you can be a lifetime of choose and buy when the meter.',
	'备注文案、欢迎语等。':'Welcome copywriting, language, etc.',
	'暂无数据':'Temporarily no data',
	'请输入关键字':'Please enter the keywords',
	'服务中心':'Service center',
	'使用条款':'Terms of use',
	'隐私协议':'Privacy agreement',
	'新闻详情':'News details',
	'当前为该语言无需切换':'For the current language without switch',
	'上一条':'front matter',
	'查看更多':'Learn More',
	'下一条':'next piece',
	'已经是第一篇了':"It's the first chapter",
	'没有下一篇了':'There is no next article',
	'巴博斯精品推荐':'Fine products recommended',
	'型号':'model',
	'欢迎来到JINLERY巴博斯腕表店':'Welcome to JINLERY jin wrist watch shop',
	'专业设计、科技创新、力求上进':'Professional design, technology innovation, and strive to progress',
	'首页':'Home',
	'切换语言': 'Choose your language',
	'搜索巴博斯网站': 'Search the BRUBOSES website',
	'品牌探索': 'Brand exploration',
	'使用与服务': 'Uses and services',
	'服务政策': 'Service Policy',
	'腕表展廊': 'Watch gallery',
	'查询不存在，请核实防伪码': 'The goods are not correct',
	'系列图片': 'Series images',
	'更多图片': 'More pictures',
	'更多视频': 'More videos',
	'详情图片': 'Detailed images',
	'腕表系列': 'Watch series',
	'真伪查询服务': 'Authenticity query service',
	'常见问题': 'FAQ',
	'服务条款': 'Term of Service',
	'隐私政策': 'Privacy policy',
	'输入20位数的纯数字检查': 'Input 20 digit pure number check',
	'返回首页': 'Back to top',
	'返回': 'Back',
	'关注巴博斯': 'Focus on BRUBOSES',
	'成为我们的一员': 'Be one of us',
	'打开微信并扫码': 'Open wechat and scan',
	'上一页': 'previous page',
	'下一页': 'next page',
	'您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。':'Hello, the watch you are inquiring about is a German watch produced by the Babos brand, which has been verified as genuine.',
	'了解更多款式':'Learn more styles'
}
export default en
